import { IApiBaseErrorResponse } from '@app/api/interfaces/api-base-error-response.interface';
import { MonthsDateRangeType } from '@app/core/date-range/enums/months-date-range-type.enum';
import { IDateRange } from '@app/core/date-range/interfaces/date-range.interface';
import { ICombinedLeakScoreChartData } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-leak-score/interfaces/combined-leak-score-chart-data';
import { ILdLogger } from '@app/main/leak-detection/interfaces/ld-logger';

export enum FpLoggerNoiseLeakScoreActionType {
  GetData = 'GetData',
  GetDataSuccesses = 'GetDataSuccesses',
  GetDataError = 'GetDataError',
  ToggleChartFullscreen = 'ToggleChartFullscreen',
  UpdatePeriod = 'UpdatePeriod',
}

export interface FpLoggerNoiseLeakScoreActionGetData {
  type: FpLoggerNoiseLeakScoreActionType.GetData;
  date: string | null;
  popupMainData: ILdLogger | null;
}

export interface FpLoggerNoiseLeakScoreActionGetDataSuccesses {
  type: FpLoggerNoiseLeakScoreActionType.GetDataSuccesses;
  date: string | null;
  cacheDateRange?: IDateRange | null;
  cacheData?: ICombinedLeakScoreChartData[] | null;
  popupMainData: ILdLogger | null;
  data: ICombinedLeakScoreChartData[] | null;
}
export interface FpLoggerNoiseLeakScoreActionGetDataError {
  type: FpLoggerNoiseLeakScoreActionType.GetDataError;
  date: string | null;
  popupMainData: ILdLogger | null;
  error: IApiBaseErrorResponse;
}

export interface FpLoggerNoiseLeakScoreActionToggleChartFullscreen {
  type: FpLoggerNoiseLeakScoreActionType.ToggleChartFullscreen;
  synchronizeWithPopupId?: string;
}

export interface FpLoggerNoiseLeakScoreActionUpdatePeriod {
  type: FpLoggerNoiseLeakScoreActionType.UpdatePeriod;
  period: MonthsDateRangeType;
}

export type FpLoggerNoiseLeakScoreActions =
  | FpLoggerNoiseLeakScoreActionGetData
  | FpLoggerNoiseLeakScoreActionGetDataSuccesses
  | FpLoggerNoiseLeakScoreActionToggleChartFullscreen
  | FpLoggerNoiseLeakScoreActionUpdatePeriod
  | FpLoggerNoiseLeakScoreActionGetDataError;
